import { Form, Input } from 'antd';

import { TFieldProps } from 'types';

const { Item } = Form;

export const FormInput = ({
  name,
  label,
  rules,
  prefix,
  hidden,
  tooltip,
  disabled,
  allowClear = true,
  addonAfter,
  placeholder,
  inputStyles,
  itemClassName,
  normalize,
  onTextChange,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    hidden={hidden}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
    normalize={normalize}
  >
    <Input
      prefix={prefix}
      style={inputStyles}
      disabled={disabled}
      allowClear={allowClear}
      addonAfter={addonAfter}
      placeholder={placeholder}
      onChange={onTextChange}
    />
  </Item>
);
